module.exports = __webpack_public_path__ + "img/mev.928d661c.svg";